import {useTranslations} from 'next-intl';

export default function MobileMenuShow() {
  const t = useTranslations('header');
  return (
    <div className="mobile-header-menu-fullwidth">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* <!-- Mobile Menu Button --> */}
            <div className="mobile-menu-toggle d-lg-none">
              <a
                  href="#ltn__utilize-mobile-categories"
                  className="ltn__utilize-toggle"
              >
                <i className="icon-menu"></i>
                <span className="ms-1">{t('catalog')}</span>
              </a>
              <a
                  href="#ltn__utilize-mobile-menu"
                  className="ltn__utilize-toggle"
              >
                <span className="me-1">{t('menu')}</span>
                <i className="fa-solid fa-bars"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
